import { AxiosError } from 'axios';

export function getApiErrorMessage(error: unknown, fallback: string): string {
  if (!(error instanceof AxiosError)) {
    return error instanceof Error ? error.message : fallback;
  }
  const data = error.response?.data as
    | { message?: string; errors?: { msg?: string }[] | string[] }
    | undefined;
  if (data?.message) return data.message;
  if (Array.isArray(data?.errors) && data.errors.length) {
    const first = data.errors[0];
    return typeof first === 'string' ? first : first?.msg || fallback;
  }
  return error.message || fallback;
}
